export const getNakladnaya = (data) => `
<div class="mainContainer">
        <div class="container">
      <div class="header">
        <div class="header_docInfo">
          <p class="bold h-09">
            ТРАНСПОРТНАЯ НАКЛАДНАЯ<br />
            № ${data.numberApplication}
          </p>
          <p class="bold h-09">от ${data.date.day} ${data.date.month} ${data.date.year} г.</p>
        </div>
        <div class="header_shippingInfo">
          <div class="carrier mb-5">
            <p class="bold h-10 mb-5">ПЕРЕВОЗЧИК:</p>
            <p class="bold mb-5">${data.organizationTitle}</p>
            <p class="bold">ИНН ${data.inn}</p>
          </div>
          <div class="forwarder">
            <p class="h-10 mb-5">ЕДИНЫЙ ЭКСПЕДИТОР: ООО «УК ЛУЧ»</p>
            <p>ИНН/КПП 7404067356/74480100</p>
          </div>
        </div>
        <img class="header_icon" alt="luchIcon" />
      </div>

      <div class="peopleInfo">
        <table class="peopleInfo_table tableRounded">
          <tr>
            <th class="peopleInfo_table__th bold">Грузоотправитель</th>
            <td class="peopleInfo_table__td">
              <div class="peopleInfo_table__td__wrapper">
                <p class="peopleInfo_table__td__wrapper__info peopleInfo_table__td__wrapper__info_custom bold">${data.sender.name}</p>
              </div>
            </td>
          </tr>
          <tr>
            <th class="peopleInfo_table__th">ИНН</th>
            <td class="peopleInfo_table__td bigTdText bold">${data.sender.inn || `<div class="emptyLineWrapper"><div class="emptyLine"></div></div>`}</td>
          </tr>
          <tr>
            <th class="peopleInfo_table__th">
              Город <br />
              отправления
            </th>
            <td class="peopleInfo_table__td bigTdText">${data.sender.city}</td>
          </tr>
          <tr>
            <th class="peopleInfo_table__th">Телефон</th>
            <td class="peopleInfo_table__td bigTdText">${data.sender.phone}</td>
          </tr>
          <tr>
            <th class="peopleInfo_table__th">
              <div class="peopleInfo_table__th_wrapper">
                <p>
                  Забор груза, <br />
                  адрес
                </p>
                <div class="boxCross bold">${data.sender.address ? '&#9587;' : ''}</div>
              </div>
            </th>
            <td class="peopleInfo_table__td bold">${data.sender.address}</td>
          </tr>
        </table>

        <table class="peopleInfo_table tableRounded">
          <tr>
            <th class="peopleInfo_table__th bold">Грузополучатель</th>
            <td class="peopleInfo_table__td">
              <div class="peopleInfo_table__td__wrapper">
                <p class="peopleInfo_table__td__wrapper__info peopleInfo_table__td__wrapper__info_custom bold">${data.consignee.name}</p>
              </div>
            </td>
          </tr>
          <tr>
            <th class="peopleInfo_table__th">ИНН</th>
            <td class="peopleInfo_table__td bigTdText bold">${data.consignee.inn || `<div class="emptyLineWrapper"><div class="emptyLine"></div></div>`}</td>
          </tr>
          <tr>
            <th class="peopleInfo_table__th">
              Город <br />
              получения
            </th>
            <td class="peopleInfo_table__td bigTdText">${data.consignee.city}</td>
          </tr>
          <tr>
            <th class="peopleInfo_table__th">Телефон</th>
            <td class="peopleInfo_table__td bigTdText">${data.consignee.phone}</td>
          </tr>
          <tr>
            <th class="peopleInfo_table__th">
              <div class="peopleInfo_table__th_wrapper">
                <p>
                  Доставка груза, <br />
                  адрес
                </p>
                <div class="boxCross bold">${data.consignee.address ? '&#9587;' : ''}</div>
              </div>
            </th>
            <td class="peopleInfo_table__td bold">${data.consignee.address}</td>
          </tr>
        </table>

        <table class="peopleInfo_table tableRounded">
          <tr>
            <th class="peopleInfo_table__th bold">
              Клиент
              <div style="font-weight: normal">(заказчик)</div>
            </th>
            <td class="peopleInfo_table__td">
              <div class="peopleInfo_table__td__wrapper">
                <p class="peopleInfo_table__td__wrapper__info peopleInfo_table__td__wrapper__info_custom bold">${data.customer.name}</p>
              </div>
            </td>
          </tr>
          <tr>
            <th class="peopleInfo_table__th bold">ИНН</th>
            <td class="peopleInfo_table__td bigTdText">${data.customer.inn || `<div class="emptyLineWrapper"><div class="emptyLine"></div></div>`}</td>
          </tr>
          <tr>
            <th class="peopleInfo_table__th">
              Телефон, <br />
              E-mail
            </th>
            <td class="peopleInfo_table__td bigTdText">
            ${data.customer.phone}
            <br/> 
            ${data.customer.email}
            </td>
          </tr>
        </table>
      </div>

      <div class="cargoInfo">
        <h1 class="h-08 mb-5">ДАННЫЕ О ГРУЗЕ (ЗАПОЛНЯЕТСЯ ПЕРЕВОЗЧИКОМ)</h1>
        <div class="cargoInfo_firstRow mb-5">
          <table class="cargoInfo_table tableRounded">
            <tr>
              <th>Характер груза</th>
              <th>Кол-во мест</th>
              <th>Вес брутто/нетто, кг</th>
              <th>Объём м3</th>
              <th>
                Соответствие <br />
                упаковки
              </th>
              <th>
                Объявленная <br />
                стоимость груза
              </th>
              <th>
                Страна происхождения,<br />
                товарный код, вид и размер упаковки
              </th>
            </tr>
            <tr>
              <td style="width: 150px" class="bold">${data.natureOfCargo}</td>
              <td class="bigTdTextTd">${data.quantityOfCargo}</td>
              <td class="bigTdTextTd"></td>
              <td class="bigTdTextTd"></td>
              <td class="bigTdTextTd"></td>
              <td class="bigTdTextTd">${data.cargoCost}</td>
              <td class="bold">-</td>
            </tr>
          </table>
        </div>
        <div class="cargoInfo_secondRow">
          <div class="infoBlock curlyBorder">
          <p class="bold mb-5">Доп. упаковка</p>
          <div class="infoBlock_items">
            ${typeof data.typeOfPackaging === 'string' ? data.typeOfPackaging : data.typeOfPackaging.map((el) => `<p class="mb-2">${el}</p>`).join('')}
          </div>
          </div>
          <table class="cargoInfo_table tableRounded cargoInfo_secondRow_table">
            <tr>
              <th>Забор груза</th>
              <th>Грузоперевозка</th>
              <th>Доставка груза</th>
              <th>Дополнительная упаковка</th>
              <th>Удорожание стоимости</th>
              <th>Доп. услуга <div class="extraServicesType">${data.extraServices[0]?.name ?? ''}</div></th>
              <th>Доп. услуга <div class="extraServicesType">${data.extraServices[1]?.name ?? ''}</div></th>
              <th>Доп. услуга <div class="extraServicesType">${data.extraServices[2]?.name ?? ''}</div></th>
            </tr>
            <tr>
              <td>
                <p class="bigTdTextTd">${data.stCalc.sumAddrPickUp + data.stCalc.sumGasolinePickUp}</p>
                <div class="cargoInfo_table__bottomInfo">
                  <p class="cargoInfo_table__bottomInfo_borderLeft ${data.sender.obligationPattern.addrPickUp ? 'invertedCell' : ''}">ОТП</p>
                  <p class="${data.consignee.obligationPattern.addrPickUp ? 'invertedCell' : ''}">ПОЛ</p>
                  <p class="${data.customerObligationPattern.addrPickUp ? 'invertedCell' : ''}">
                    3-е <br />
                    лицо
                  </p>
                </div>
              </td>
              <td>
                <p class="bigTdTextTd">${data.stCalc.sumCarrying}</p>
                <div class="cargoInfo_table__bottomInfo">
                  <p class="${data.sender.obligationPattern.carrying ? 'invertedCell' : ''}">ОТП</p>
                  <p class="${data.consignee.obligationPattern.carrying ? 'invertedCell' : ''}">ПОЛ</p>
                  <p class="${data.customerObligationPattern.carrying ? 'invertedCell' : ''}">
                    3-е <br />
                    лицо
                  </p>
                </div>
              </td>
              <td>
                <p class="bigTdTextTd">${data.stCalc.sumAddrDelivery + data.stCalc.sumGasolineDelivery}</p>
                <div class="cargoInfo_table__bottomInfo">
                  <p class="${data.sender.obligationPattern.addrDelivery ? 'invertedCell' : ''}">ОТП</p>
                  <p class="${data.consignee.obligationPattern.addrDelivery ? 'invertedCell' : ''}">ПОЛ</p>
                  <p class="${data.customerObligationPattern.addrDelivery ? 'invertedCell' : ''}">
                    3-е <br />
                    лицо
                  </p>
                </div>
              </td>
              <td>
                <p class="bigTdTextTd">${data.stCalc.sumPacking}</p>
                <div class="cargoInfo_table__bottomInfo">
                  <p class="${data.sender.obligationPattern.packing ? 'invertedCell' : ''}">ОТП</p>
                  <p class="${data.consignee.obligationPattern.packing ? 'invertedCell' : ''}">ПОЛ</p>
                  <p class="${data.customerObligationPattern.packing ? 'invertedCell' : ''}">
                    3-е <br />
                    лицо
                  </p>
                </div>
              </td>
              <td>
                <p class="bigTdTextTd">${data.stCalc.sumInsuranceForValue}</p>
                <div class="cargoInfo_table__bottomInfo">
                  <p class="${data.insuranceForValuePayer === 'Отправитель' ? 'invertedCell' : ''}">ОТП</p>
                  <p class="${data.insuranceForValuePayer === 'Получатель' ? 'invertedCell' : ''}">ПОЛ</p>
                  <p class="${data.insuranceForValuePayer === 'Заказчик' ? 'invertedCell' : ''}">
                    3-е <br />
                    лицо
                  </p>
                </div>
              </td>
              <td>
                <p class="extraServices">${data.extraServices[0]?.info ?? ''}</p>
                <div class="cargoInfo_table__bottomInfo">
                  <p class="${data.extraServices[0]?.payer === 'Отправитель' ? 'invertedCell' : ''}">ОТП</p>
                  <p class="${data.extraServices[0]?.payer === 'Получатель' ? 'invertedCell' : ''}">ПОЛ</p>
                  <p class="${data.extraServices[0]?.payer === 'Заказчик' ? 'invertedCell' : ''}">
                    3-е <br />
                    лицо
                  </p>
                </div>
              </td>
              <td>
                <p class="extraServices">${data.extraServices[1]?.info ?? ''}</p>
                <div class="cargoInfo_table__bottomInfo">
                  <p class="${data.extraServices[1]?.payer === 'Отправитель' ? 'invertedCell' : ''}">ОТП</p>
                  <p class="${data.extraServices[1]?.payer === 'Получатель' ? 'invertedCell' : ''}">ПОЛ</p>
                  <p class="${data.extraServices[1]?.payer === 'Заказчик' ? 'invertedCell' : ''}">
                    3-е <br />
                    лицо
                  </p>
                </div>
              </td>
              <td>
                <p class="extraServices">${data.extraServices[2]?.info ?? ''}</p>
                <div class="cargoInfo_table__bottomInfo">
                  <p class="${data.extraServices[2]?.payer === 'Отправитель' ? 'invertedCell' : ''}">ОТП</p>
                  <p class="${data.extraServices[2]?.payer === 'Получатель' ? 'invertedCell' : ''}">ПОЛ</p>
                  <p class="${data.extraServices[2]?.payer === 'Заказчик' ? 'invertedCell' : ''} cargoInfo_table__bottomInfo_borderRight">
                    3-е <br />
                    лицо
                  </p>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div class="footerGrid">
        <div class="infoBlock curlyBorder infoBlockGrid">
          <p class="bold mb-5">
            Особые отметки, <br />
            сопроводительные <br />
            документы, <br />
            трек-номер
          </p>
          <div class="infoBlock_items">
            <p>нет</p>
          </div>
        </div>
        <div class="payment curlyBorder">
          <div class="payment_qrInfo">
            <p class="payment_qrLabel">
              ОПЛАТИ <br />
              ОНЛАЙН
            </p>
            <div class="payment_qrImg"></div>
          </div>
          <div class="payment_info">
            <div class="payment_peopleInfo">
              <table class="payment_table">
                <tr>
                  <th class="${data.senderPaymentType === 'Не платит' ? '' : 'bold'}">Отправитель</th>
                </tr>
                <tr>
                  <th class="${data.consigneePaymentType === 'Не платит' ? '' : 'bold'}">Получатель</th>
                </tr>
                <tr>
                  <th class="${data.customerPaymentType === 'Не платит' ? '' : 'bold'}">3-е лицо</th>
                </tr>
              </table>
            </div>
            <div class="payment_money">
              <table class="payment_table">
                <tr>
                  <th class="payment_amount">${data.senderSumTotal}</th>
                </tr>
                <tr>
                  <th class="payment_amount">${data.consigneeSumTotal}</th>
                </tr>
                <tr>
                  <th class="payment_amount">${data.customerSumTotal}</th>
                </tr>
              </table>
            </div>
            <div class="payment_way">
              <table class="payment_table">
                <tr>
                  <td class="${data.senderPaymentType === 'Наличные' ? 'invertedCell' : ''}">Нал</td>
                  <td class="${data.senderPaymentType === 'Расчётный счёт юр.лица' ? 'invertedCell' : ''}">БН</td>
                </tr>
                <tr>
                  <td class="${data.consigneePaymentType === 'Наличные' ? 'invertedCell' : ''}">Нал</td>
                  <td class="${data.consigneePaymentType === 'Расчётный счёт юр.лица' ? 'invertedCell' : ''}">БН</td>
                </tr>
                <tr>
                  <td class="${data.customerPaymentType === 'Наличные' ? 'invertedCell' : ''}">Нал</td>
                  <td class="${data.customerPaymentType === 'Расчётный счёт юр.лица' ? 'invertedCell' : ''}">БН</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div class="signature curlyBorder">
          <div class="signature_row signature_row__first">
            <p class="bold">
              Груз мною отправлен,<br />
              с условиями согласен
            </p>
            <div class="payment_tick">&#x2713;</div>
            <p class="textPlaceholderPayment">подпись</p>
            <div class="payment_tick">&#x2713;</div>
            <p class="textPlaceholderPayment">расшифровка</p>
          </div>
          <div class="signature_row signature_row__second">
            <div class="signature_row__second_firstPart">
              <p class="bold">
                Груз к перевозке<br />
                принял <br />
              </p>
              <p class="textPlaceholderPayment">подпись</p>
              <p class="textPlaceholderPayment">расшифровка</p>
            </div>
            <div class="signature_row__second_secondPart">
              <p class="bold mb-2">${data.organizationTitle}</p>
              <p class="bold">ИНН ${data.inn}</p>
            </div>
          </div>
        </div>
        <div class="seal curlyBorder">
          <p class="textPlaceholderSeal">
            <span style="font-size: 0.9rem;">Место под <br />
            печать</span>
          </p>
          <p class="textPlaceholderSeal">
            ВСЕ ГОРОДА <span style="text-decoration: underline">НА</span> <br />
            <span style="font-weight: 1000; font-size: 1.1rem;">ТК-ЛУЧ.РФ</span>
          </p>
        </div>
        <div class="warningInfo">
          Подписание настоящего документа является согласием с размещенной на официальном сайте www.тк-луч.рф/dokumenty офертой (договором перевозки) и означает принятие и согласие с условиями оферты,
          а также гарантирует, что им получено от Плательщика и Грузополучателя согласие с условиями указанного договора, а также тарифами. Клиент уведомлен, о необходимости изготовления защитной
          транспортной упаковки для данного вида груза для обеспечения целостности и сохранности при транспортировке. Подписывая данную транспортную накладную, клиент дает безусловное согласие на
          обработку и передачу третьим лицам, которые задействованы в осуществлении перевозки своих персональных данных. Клиент подтверждает, что дает свое согласие Перевозчику на досмотр (осмотр и
          т.п.) переданного Перевозчику груза государственными и/или муниципальными органами, в т.ч. вскрытие ими упаковки, осмотр вложенного содержимого, соответствия его характера заявленному в
          сопроводительных документах и производство ими иных необходимых действий, с предварительного оповещения Перевозчиком клиента. <span class="bold">ВНИМАНИЕ:</span> после фактического
          взвешивания и измерения объема груза указанные клиентом данные могут быть изменены перевозчиком, исходя из фактического веса/объема груза.
        </div>
      </div>
    </div>
  </div>
`;
